/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import {
    actionsAndNotesWrapper,
    extendedProductTileStyles,
    notesStyles,
    notesWrapper,
} from "@monsma/App/WidgetExtensions/MyListsDetails/MyListsDetailsExtension";
import { productListLineStyles } from "@monsma/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { screen } from "@monsma/XDL/Helpers";
import ArrowsRotate from "@monsma/XDL/Icons/ArrowsRotate";
import Check from "@monsma/XDL/Icons/Check";
import StickyNote from "@monsma/XDL/Icons/StickyNote";
import { removeLinkStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

(productListLineStyles as any).extendedProductTileStyles = extendedProductTileStyles;

(productListLineStyles as any).selectedCheckboxWrapper = {
    css: css`
        display: flex;
        height: 100%;
        align-items: center;

        ${screen("lte", "md")} {
            display: flex;
            padding: 0;
            margin-bottom: 15px;
        }

        @media print {
            display: none;
        }
    `,
};

(productListLineStyles as any).otherMiddleActionsWrapper = {
    css: css`
        display: flex;
        margin-top: 15px;
        justify-content: flex-start;

        & > button {
            flex: 1 1 50%;
            margin: 0;
        }
    `,
};

(productListLineStyles as any).notesWrapper = notesWrapper;

(productListLineStyles as any).actionsAndNotesWrapper = actionsAndNotesWrapper;

(productListLineStyles as any).initialspaceWrapper = {
    css: css`
        ${screen("lte", "md")} {
            min-height: 30px;
        }

        @media print {
            display: none;
        }
    `,
};

productListLineStyles.notesStyles = notesStyles;

productListLineStyles.deleteLink = removeLinkStyle;

productListLineStyles.selectedCheckbox = {
    sizeVariant: "small",
    css: css`
        @media print {
            display: none;
        }
        margin-right: 20px;

        ${screen("lte", "md")} {
            margin: 0;
        }
    `,
};

productListLineStyles.editNotesLink = {
    css: css`
        ${getProp("theme.link.defaultProps.css")};
        margin-top: 5px;
    `,
    icon: {
        iconProps: {
            src: StickyNote,
            color: "common.ui5",
            size: 12,
            css: css`
                margin-right: 5px;
            `,
        },
    },
    typographyProps: { size: 12 },
};

productListLineStyles.updateQuantityLink = {
    typographyProps: { size: 12 },
    icon: {
        iconProps: {
            src: ArrowsRotate,
            color: "common.ui5",
            size: 12,
            css: css`
                margin-right: 5px;
            `,
        },
    },
};

productListLineStyles.quantityUpdatedIcon = {
    src: Check,
    color: "success.main",
    size: 12,
    css: css`
        margin-right: 5px;
    `,
};

productListLineStyles.quantityUpdatedText = {
    size: 12,
    color: "success.main",
    lineHeight: 1,
};

productListLineStyles.updateQuantityWrapper = {
    css: css`
        display: flex;
        flex: 1;
        align-items: flex-end;
    `
};
